import { useState } from 'react'
import { Trans } from '@lingui/macro'
import { Button, MenuItem } from '@mui/material'
import PermIdentityRoundedIcon from '@mui/icons-material/PermIdentityRounded'

import { useIsLargeScreen } from '@/hooks/useIsLargeScreen'

import { CheckInsAndIdentityDialog } from './CheckInsAndIdentityDialog'

type CheckInsAndIdentityButtonProps = {
  onClose?: () => void
}

export function CheckInsAndIdentity({ onClose }: CheckInsAndIdentityButtonProps) {
  const isLargeScreen = useIsLargeScreen()

  const [openCheckINSAndIdentityDialog, setOpenCheckINSAndIdentityDialog] = useState(false)

  return (
    <>
      {isLargeScreen ? (
        <Button onClick={() => setOpenCheckINSAndIdentityDialog(true)} variant="contained">
          <Trans>Check INS and Identity</Trans>
        </Button>
      ) : (
        <MenuItem
          disableRipple
          onClick={() => {
            setOpenCheckINSAndIdentityDialog(true)
          }}
        >
          <PermIdentityRoundedIcon />
          <Trans>Check INS And Identity</Trans>
        </MenuItem>
      )}
      <CheckInsAndIdentityDialog
        open={openCheckINSAndIdentityDialog}
        onClose={() => {
          setOpenCheckINSAndIdentityDialog(false)
          onClose?.()
        }}
      />
    </>
  )
}
